import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const serviceWebhookApi = createApi({
  reducerPath: "serviceWebhookApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["webhookLogs"],
  endpoints: (build) => ({
    loadLogs: build.query<
      ServiceWebhookLog[],
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `/${companyId}/services/${serviceId}/webhooks/logs`,
        method: "GET",
      }),
      providesTags: ["webhookLogs"],
    }),
  }),
});
